import React from 'react';
import { Box } from 'src/components/Box';
import { Scroller } from 'src/components/Scroller';
import { TitleAndClose } from 'src/components/TitleAndClose';

import { useSidebarDialog } from './SidebarDialogContext';
import { SidebarDialogContentProps } from './SidebarDialogTypes';

export const SidebarDialogContent: React.FC<SidebarDialogContentProps> = ({
  children,
  title,
  subtitle,
  leftAdornment,
  actions,
}) => {
  const {
    isMobile,
    sidebarOpen,
    onClose,
    hasFab,
    dialogTitle,
    dialogSubtitle,
    dialogLeftAdornment,
    dialogActions,
  } = useSidebarDialog();

  // Check if we have a sidebar showing (desktop with sidebar open)
  const hasSidebar = !isMobile && sidebarOpen;

  // Use local props if provided, otherwise fall back to context props
  const finalTitle = title ?? dialogTitle;
  const finalSubtitle = subtitle ?? dialogSubtitle;
  const finalLeftAdornment = leftAdornment ?? dialogLeftAdornment;
  const finalActions = actions ?? dialogActions;

  if (hasSidebar) {
    // When sidebar is showing, use the layout with TitleAndClose and Scroller
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'nowrap',
        }}
      >
        <TitleAndClose
          onClose={onClose}
          title={finalTitle}
          subtitle={finalSubtitle}
          leftAdornment={finalLeftAdornment}
        />
        <Scroller direction="column" sx={{ px: 2, height: '100%' }}>
          <Box sx={{ pb: hasFab ? '130px' : 4 }}>{children}</Box>
        </Scroller>
        {finalActions && <Box p={2}>{finalActions}</Box>}
      </Box>
    );
  }

  // When no sidebar (mobile or sidebar closed), use simpler layout
  return <Box sx={{ pb: hasFab ? '130px' : 4 }}>{children}</Box>;
};
